export default function Data() {
  return <div>Data</div>;
}
